import { REQUEST_SUCCESS } from "../../middlewares/api/actions";
import { ARTEFACT_FULL_EXPORT,
         ARTEFACT_FULL_EXPORT_SHOW,
         ARTEFACT_FULL_EXPORT_HIDE,
         ARTEFACT_FULL_EXPORT_CHANGE
} from "./actions";
import _ from "lodash";

const artefactFullExportReducer = (
    state = {
        isVisible: false,
        artefactsData: null,
        downloadForm: {
            separator: ';',
            delimiter: null,
            isCompressed: false,
            lang: null
        },
        columnsMap: {}
    },
    action
) => {
    switch (action.type) {
        case ARTEFACT_FULL_EXPORT_SHOW:
            return {
                ...state,
                isVisible: true,
                artefactsData: action.payload.artefactsData,
                columnsMap: action.payload.columnsMap
            }
        case ARTEFACT_FULL_EXPORT_HIDE:
            return {
                ...state,
                isVisible: false,
                artefactsData: null,
                downloadForm: {
                    separator: ';',
                    delimiter: null,
                    isCompressed: false,
                    lang: null
                },
                columnsMap: {}
            }
        case ARTEFACT_FULL_EXPORT_CHANGE:
            const downloadForm = _.cloneDeep(state.downloadForm);
            return {
                ...state,
                downloadForm: _.merge(downloadForm, action.fields)
            }
        case REQUEST_SUCCESS:
            switch(action.label) {
                case ARTEFACT_FULL_EXPORT:
                    return {
                        ...state,
                        isVisible: false,
                        artefactsData: null,
                        downloadForm: {
                            separator: ';',
                            delimiter: null,
                            isCompressed: false,
                            lang: null
                        },
                        columnsMap: {}
                    }
            }
        default:
            return {
                ...state
            }
    }
}

export default artefactFullExportReducer;
